import { HeaderEndpointService } from "@/views/loyalty/shared/endpoint_services/header-endpoint-service"

export class HeaderService {
    constructor (model, url) {
        this.model = model
        this.headerEndpointService = new HeaderEndpointService(url)
    }

    get_header (data) {
        return this.model.filter(f => f.value !== "actions").map(m => {
            if (data) {
                Reflect.set(m, 'show', !!data.headers.includes(m.value))
            } else {
                Reflect.set(m, 'show', true)
            }
            return m
        })
    }

    get_header_list (data) {
        return this.model.filter(item => {
            if (item.value === "actions") {
                return true
            } else {
                if (data) {
                    if (data.headers.includes(item.value)) {
                        return true
                    }
                } else {
                    return true
                }
            }
        })
    }

    async set_header (entity, userId, data) {
        const obj = { userId: userId, entity: entity, headers: [] }
        obj.headers = data.filter(item => item.show).map(m => m.value)
        // await this.create_header(obj)
        return obj
    }

    async read_header (entity, client) {
        return this.headerEndpointService.read_header(entity, client)
    }

    async create_header (headers) {
        return this.headerEndpointService.create_header(headers)
    }
}
